import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getEnvVariables } from '../../helpers/getEnvVariables';
const { REACT_APP_URL } = getEnvVariables();

export const geoApi = createApi({
    reducerPath: 'geo',
    baseQuery: fetchBaseQuery({ baseUrl: REACT_APP_URL }),
    endpoints: (builder) => ({
        getCities: builder.query({
            query: () => 'canton-search',
        }),
    }),
});

export const { useGetCitiesQuery } = geoApi;